import { render, staticRenderFns } from "./classifiedGoods.vue?vue&type=template&id=7676d4d3&scoped=true"
import script from "./classifiedGoods.vue?vue&type=script&lang=ts"
export * from "./classifiedGoods.vue?vue&type=script&lang=ts"
import style0 from "./classifiedGoods.vue?vue&type=style&index=0&id=7676d4d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7676d4d3",
  null
  
)

export default component.exports